import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from '../../components/molecules/TextField';
import css from './Input.css';

const Input = ({
    value,
    placeholder,
    onChange,
    onBlur,
    disabled,
    inputClassName,
    containerClass,
    error,
    required = false,
}) => {
    const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
    const showRequiredOverlay = required && !value && !!placeholder;
    // Don't paint the red required-border on first paint — wait until the user has interacted
    // with the field at least once (blurred). This avoids a hostile-feeling form on initial load.
    const errorInput = error || (required && !value && hasBeenBlurred);
    const handleBlur = e => {
        setHasBeenBlurred(true);
        if (onBlur) onBlur(e);
    };
    return (
        <div className={classNames(css.container, containerClass)}>
            <TextField
                value={value}
                onChange={onChange}
                onBlur={handleBlur}
                disabled={disabled}
                placeholder={required ? null : placeholder}
                inputClassName={classNames(css.cellInput, { [css.errorInput]: errorInput }, inputClassName)}
                containerClass={css.textField}
            />
            {showRequiredOverlay && (
                <span className={classNames(css.placeholder, { [css.withError]: error })}>
                    {placeholder} <span className={css.requiredStar}>*</span>
                </span>
            )}
            {error && <span className={css.errorHint}>{error}</span>}
        </div>
    );
};

Input.propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    inputClassName: PropTypes.string,
    containerClass: PropTypes.string,
    error: PropTypes.string,
    required: PropTypes.bool,
};

export default Input;
